import { hasCapability } from 'helpers';
import { useCapabilities } from 'hooks';
import React, { FC } from 'react';

import { MetaNoAuthToShare, MetaAuthToShare } from './index';

const MetaPublic: FC = () => {
  const capabilities = useCapabilities();

  const hasAuthToShare = hasCapability(capabilities, `Sharing.Function.AuthToShare`);

  if (hasAuthToShare) {
    return <MetaAuthToShare />;
  }

  return <MetaNoAuthToShare />;
};

export default MetaPublic;
